import { PAGES } from './sentryLogger';

// Components for error logging
export const COMPONENTS = {
    ADD_GIFTCARD_FORM: 'AddGiftCardForm',
    AFTERPAY: 'Afterpay',
    AFTERPAY_PAYPAL: 'AfterpayPayPal',
    CART_PAGE: 'CartPage',
    CART_PROVIDER: 'CartProvider',
    CART_SERVICE: 'cartService',
    CREDIT_CARD: 'CreditCardPayment',
    FULFILLMENT_METHODS: 'FulfillmentMethods',
    ORDER_SUMMARY: 'OrderSummary',
    ORDER_SUMMARY_CHECKOUT: 'OrderSummaryCheckout',
    PAYMENT_METHOD: 'PaymentMethod',
    PAYPAL: 'PayPal',
    PROMO_CODE_FORM: 'PromoCodeForm',
    SDD_DRAWER_ADDRESS_FORM: 'SddDrawerAddressForm',
    SHIPPING_ADDRESS_FORM: 'ShippingAddressForm',
    TREATS: 'Treats',
    USE_HANDLE_ORDER_PLACING_ERROR: 'useHandleOrderPlacingError',
    USE_VALIDATE_CART_ON_INITIAL_LOAD: 'useValidateCartOnInitialLoad',
    VET_CLINIC_DROPDOWN: 'VetClinicDropdown',
};

// Error messages for cart operations
export const CART_ERROR_MESSAGES = {
    ADD_BILLING_ADDRESS_FAILED: 'Failed to add billing address',
    ADD_DISCOUNT_CODE_FAILED: 'Failed to add discount code',
    ADD_DONATION_FAILED: 'Failed to add donation',
    ADD_ITEM_FAILED: 'Failed to add item to cart',
    ADD_PAYMENT_FAILED: 'Failed to add payment method',
    ADD_PICKUP_INFO_FAILED: 'Failed to add pickup information',
    ADD_PRESCRIPTION_FAILED: 'Failed to add prescription',
    ADD_SHIPPING_ADDRESS_FAILED: 'Failed to add shipping address',
    ADD_TREAT_POINTS_FAILED: 'Failed to add treat points',
    CART_INITIALIZATION_FAILED: 'Cart initialization failed',
    CART_NOT_FOUND: 'Cart not found',
    CART_UPDATE_FAILED: 'Cart update failed',
    CHANGE_FULFILLMENT_METHOD_FAILED: 'Failed to change fulfillment method',
    FAILED_TO_INITIALIZE_PAYPAL_CHECKOUT:
        'Failed to initialize PayPal checkout',
    FETCH_CART_FAILED: 'Failed to fetch cart',
    FETCH_STORES_FAILED: 'Failed to fetch stores',
    GET_DELIVERY_OPTIONS_FAILED: 'Failed to get delivery options',
    GET_SHIPPING_METHODS_FAILED: 'Failed to get shipping methods',
    NAVIGATE_TO_CHECKOUT_FAILED: 'Failed to navigate to checkout',
    PLACE_AFTERPAY_ORDER_FAILED: 'Failed to place Afterpay order',
    PLACE_AFTERPAY_ORDER_FAILED_WITH_DETAILS:
        'Failed to place Afterpay order with details',
    PLACE_ORDER_FAILED: 'Failed to place order',
    PLACE_PAYPAL_ORDER_FAILED: 'Failed to place PayPal order',
    REMOVE_DISCOUNT_CODE_FAILED: 'Failed to remove discount code',
    REMOVE_DONATION_FAILED: 'Failed to remove donation',
    REMOVE_ITEM_FAILED: 'Failed to remove item from cart',
    REMOVE_PAYMENT_FAILED: 'Failed to remove payment method',
    REMOVE_TREAT_POINTS_FAILED: 'Failed to remove treat points',
    SET_DELIVERY_OPTIONS_FAILED: 'Failed to set delivery options',
    SET_SHIPPING_METHODS_FAILED: 'Failed to set shipping methods',
    UPDATE_ITEM_FAILED: 'Failed to update item in cart',
    UPDATE_SHIPPING_ADDRESS_FAILED: 'Failed to update shipping address',
    VALIDATE_CART_FAILED: 'Failed to validate cart',
    VALIDATE_SHIPPING_ADDRESSES_FAILED: 'Failed to validate shipping addresses',
};

// Error messages for payment operations
export const PAYMENT_ERROR_MESSAGES = {
    AFTERPAY_PROCESSING_FAILED: 'Failed to process Afterpay payment',
    CREDIT_CARD_PROCESSING_FAILED: 'Failed to process credit card payment',
    NAVIGATE_TO_CHECKOUT_FAILED: 'Failed to navigate to checkout',
    PAYPAL_PROCESSING_FAILED: 'Failed to process PayPal payment',
};

// Error messages for user interactions
export const USER_INTERACTION_ERROR_MESSAGES = {
    FORM_SUBMISSION_FAILED: 'Failed to submit form',
    UNEXPECTED_ERROR: 'An unexpected error occurred',
    VALIDATION_FAILED: 'Validation failed',
};

// Combine all error messages for export
export const ERROR_MESSAGES = {
    ...CART_ERROR_MESSAGES,
    ...PAYMENT_ERROR_MESSAGES,
    ...USER_INTERACTION_ERROR_MESSAGES,
};

// Map error messages to Sentry contexts for consistent tracking
export const ERROR_MESSAGE_TO_CONTEXT_MAP = {
    [CART_ERROR_MESSAGES.ADD_ITEM_FAILED]: {
        page: PAGES.cart,
        action: 'CART_ADD_ITEM_ERROR',
    },
    [CART_ERROR_MESSAGES.VALIDATE_CART_FAILED]: {
        page: PAGES.cartOrCheckout,
        action: 'CART_VALIDATION_ERROR',
    },
    [CART_ERROR_MESSAGES.FETCH_STORES_FAILED]: {
        page: PAGES.cart,
        action: 'CART_FETCH_STORES_ERROR',
    },
    [CART_ERROR_MESSAGES.CHANGE_FULFILLMENT_METHOD_FAILED]: {
        page: PAGES.cart,
        action: 'CART_CHANGE_FM_ERROR',
    },
    [PAYMENT_ERROR_MESSAGES.CREDIT_CARD_PROCESSING_FAILED]: {
        page: PAGES.checkout,
        action: 'CC_ORDER_ERROR',
    },
    [PAYMENT_ERROR_MESSAGES.PAYPAL_PROCESSING_FAILED]: {
        page: PAGES.checkout,
        action: 'PAYPAL_ORDER_ERROR',
    },
    [PAYMENT_ERROR_MESSAGES.NAVIGATE_TO_CHECKOUT_FAILED]: {
        page: PAGES.cart,
        action: 'NAVIGATE_TO_CHECKOUT_FAILED',
    },
};
